import styled from "styled-components";
import { StyledButton } from "../Button";

export const SAdminSearchScore = styled.section`
	${StyledButton} {
		margin-top: 5rem;
		margin-left: 2.4rem;
		&:first-of-type {
			margin-left: 0;
		}
	}
`;

export const STable = styled.table`
	border-collapse: collapse;
	table-layout: fixed;
	width: 100%;
	thead {
		tr {
			background-color: #dde5ef;
			border-bottom: 1px solid #4d6382;

			td {
				padding: 1.1rem 2rem;
				font-size: 1.2rem;
				font-weight: 500;
			}
		}
	}
	tbody {
		tr {
			background: #fff;
			td {
				padding: 0.6rem 1.8rem;
				font-size: 1.4rem;
				font-weight: 300;
				button {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					background: none;
					border: none;
					cursor: pointer;
					padding: 0.4rem;
					&[disabled] {
						cursor: not-allowed;
					}
				}
			}
		}
	}
	tfoot {
		tr {
			background: #fff;
			border-top: 1px solid #4d6382;

			td {
				padding: 1.1rem 2rem;
				font-size: 1.4rem;
				font-weight: 500;
			}
		}
	}
`;

export const SEdit = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
	span {
		width: 2.4rem;
		text-align: center;
	}
`;
